import * as React from "react";
import { PuffLoader } from "react-spinners";
import styled from "styled-components";

import { Colors } from "src/library/utils";

import type { ILoaderStyled } from "./LoadingSpinner";

interface IPuffLoaderSpinner {
  size?: number;
  color: keyof Colors;
}

/**
 * Custom styled PuffLoader
 */
const PuffLoaderStyled = styled(PuffLoader).attrs(({ customColor, theme }: ILoaderStyled) => ({ color: theme.colors[ customColor ] }))<ILoaderStyled>``;

/**
 * A PuffLoader loading spinner
 */
const PuffLoaderSpinner = ({ size, color }: IPuffLoaderSpinner) => {
  const sizeDefault = 10;

  // Set option props with default values
  size = size || sizeDefault;

  return (
    <PuffLoaderStyled
      customColor={color}
      size={size}
    />
  );
};

export default PuffLoaderSpinner;
